import formatDate, { formatRelativeTime } from "core-web/utils/formatDate";
import { getState } from "core-web/state";
import i18next from "i18next";
import transformFlexibleBackground from "theme/libs/wordpress/utils/transformFlexibleBackground";

// Transform the articledata returned from algolia
const transformArticle = (algoliaArticleData, buttonText) => {
    const application = getState("application") || {};
    const locale = application.locale;
    const pathPrefix = application.path;
    const hiddenCategories = ["Uncategorized", "Okategoriserad"];

    const {
        category,
        created: createdAt,
        external_id: id,
        primary_category: primaryCategory,
        settings,
        tags,
        title,
        url,
    } = algoliaArticleData;

    // Strip locale prefix from url – Router basename already includes it, so links must be relative
    const link = pathPrefix && url && url.startsWith(pathPrefix) ? url.slice(pathPrefix.length) || "/" : url;

    const date = new Date(createdAt * 1000);
    let created = formatDate(date, "d MMMM yyyy", locale);
    let createdShort = formatDate(date, "d/M/yyyy", locale);

    if (settings?.date_published?.length) {
        created = settings.date_published;
        createdShort = settings.date_published;
    } else if (settings?.post?.date) {
        created = formatDate(new Date(settings.post.date), "d MMMM yyyy", locale);
        createdShort = formatDate(new Date(settings.post.date), "d/M/yyyy", locale);
    }

    const publishedDate =
        settings?.post?.date && String(settings.post.date).trim() ? new Date(settings.post.date) : date;
    const publishedAgo = formatRelativeTime(publishedDate, locale);

    // Algolia returns nested settings.post.background_image; fallback to flat settings.image
    const normalizeBackgroundImage = (bg) => {
        if (!bg) return bg;
        const bgSettings = bg.background_image_settings || {};
        return { ...bg, ...bgSettings };
    };
    const backgroundImage = settings?.post?.background_image
        ? {
              desktop: normalizeBackgroundImage(settings.post.background_image.desktop_background_image),
              mobile: normalizeBackgroundImage(settings.post.background_image.mobile_background_image),
          }
        : settings?.image;

    return {
        ...algoliaArticleData,
        background: transformFlexibleBackground(backgroundImage, "image"),
        previewText: settings?.preview_text || settings?.post?.ingress || "",
        button: {
            buttonTheme: "transparentWhite",
            label: buttonText || i18next.t("read_more"),
            link,
        },
        categories: (category || [])
            .sort()
            .filter((cat) => hiddenCategories.indexOf(cat) === -1)
            .join(" | "),
        category: primaryCategory,
        created,
        createdShort,
        publishedAgo,
        heading: title,
        id,
        link,
        tag: (Object.values(tags) || []).sort().join(" | "),
    };
};

export default transformArticle;
